import { getVisitorFetchParams } from "../../components/flowPlayer/FlowPlayerHelpers";

export function getPortalVisitorFetchParams() {
  return {
    ...getVisitorFetchParams(),
    with_visitor_type_portal_layout_data: true,
    with_layout_layout_data: true,
    with_layout_item_children_data: true,
    with_layout_item_image_data: true,
  };
}
